export const CONTRACT_VERSION = '0.50.0';